/* eslint-disable camelcase */
// Preact
// eslint-disable-next-line no-unused-vars
import { h } from "preact";
import { useContext } from "preact/hooks";
import { SearchContext } from "../contexts/Search";
import Skeleton from "./Skeleton";

/**
 * The main component.
 *
 * @return {Object} JSX
 */
const Header = () => {
	const { state, helpers } = useContext(SearchContext);
	const {
		params,
		postsPerPage,
		foundPosts,
		currentSelections,
		page,
		loading,
		facets,
	} = state;
	const { getMessage, update } = helpers;
	const message = getMessage({
		params,
		postsPerPage,
		foundPosts,
		currentSelections,
		page,
		short: true,
	});

	/**
	 * Handles the sort change.
	 *
	 * @param {Object} event The event object.
	 */
	const handleOnChange = (event) => {
		const { target } = event;
		const { value } = target;

		event.preventDefault();

		// Bail if loading.
		if (loading) {
			return;
		}

		// Serialize the form for updated fields.
		const updatedParams = { ...params, sort_by: value };

		// Send a request.
		update(updatedParams);
	};

	// Render component.
	return (
		<div className="faceted-search-results__header">
			<div className="pb-3 d-sm-flex align-items-center">
				{0 !== foundPosts && (
					<Skeleton className="faceted-search-results__header-message m-0 mb-2 mb-sm-0">
						<p className="m-0">{message}</p>
					</Skeleton>
				)}

				{facets &&
					facets.map(({ label, items, id }, index) => {
						// Skip all but sort by.
						if ("sort-by" !== id) {
							return;
						}

						return (
							<div
								className="faceted-search-results__header-sort ml-auto"
								key={index}
							>
								<Skeleton className="form-inline">
									<label
										htmlFor={id}
										className="d-inline-block mr-g"
									>
										{label}
									</label>
									<div className="custom-select d-inline-block w-auto">
										<select
											className="custom-select-input btn btn-faint-secondary border-transparent"
											id={id}
											name="sort_by"
											data-bi-bhvr="6"
											form="faceted-search-form"
											onChange={handleOnChange}
										>
											{items &&
												items.map(
													({
														id: itemId,
														value: itemValue,
														label: itemLabel,
														selected,
													}) => (
														<option
															value={itemValue}
															key={`${itemId}-${itemValue}`}
															selected={selected}
														>
															{itemLabel}
														</option>
													),
												)}
										</select>
										<span
											className="custom-select-arrow"
											aria-hidden="true"
										></span>
									</div>
								</Skeleton>
							</div>
						);
					})}
			</div>
		</div>
	);
};

export default Header;
